import { Box, Theme } from "@mui/material";
import { SxProps } from "@mui/system";
import { ReactNode } from "react";

export type AlarmDashboardGraphContainerProps = {
    children?: ReactNode;
    sx?: SxProps<Theme>
};

export default function AlarmDashboardGraphContainer({
    children,
    sx
}: AlarmDashboardGraphContainerProps) {

   return (
       <Box
           sx={{
               display: 'flex',
               flex: '1 1 auto',
               minHeight: 400,
               ...sx
           }}>
           {children}
       </Box>
   );
}
